import { IPaginateProducts } from './../../../common-dtos/get-all-paginate';
import ApiService from "../../../utils/base-api/api-service";
import { IGetCreateData } from "./dtos/create-data";
import { ICreateLanguage } from "./dtos/create-langauge";
import { ILanguageList } from "./dtos/language-list";
import { ICreateResources, IResourcesList, ISearchResource } from './dtos/resources-list';






class LanguageService extends ApiService {
    constructor() {
        super({
            baseURL: '/AdminLanguage',
        });
    }

    languageList(): Promise<ILanguageList> {
        return this.post("/List")
    }

    getCreateData(): Promise<IGetCreateData> {
        return this.post("/GetCreateData")
    }


    createLanguage(dataLanguage: ICreateLanguage) {
        return this.post("/create", dataLanguage)
    }

    updateLanguage(dataLanguage: ICreateLanguage) {
        return this.post("/Edit", dataLanguage)
    }

    getLanguageByID(languageId: string): Promise<IGetCreateData> {
        return this.get("/GetLanguageById", {
            params: {
                id: languageId
            }
        })

    }

    deleteLanguage(languageId: string) {
        return this.post("/Delete", undefined, {
            params: {
                id: languageId
            }
        })
    }

    getLanguageResources(languageId: string, dataSearch: ISearchResource, queryPaginate?: IPaginateProducts): Promise<IResourcesList> {
        return this.post("/Resources", dataSearch, {
            params: {
                ...queryPaginate,
                languageId
            }
        })
    }


    deleteLanguageResources(languageId: string) {
        return this.post("/ResourceDelete", undefined, {
            params: {
                id: languageId,
            }
        })
    }

    createLanguageResources(dataCreated: ICreateResources) {
        return this.post("/ResourceAdd", dataCreated)
    }

    updateLanguageResources(dataUpdate: ICreateResources) {
        return this.post("/ResourceUpdate", dataUpdate)
    }

    importXmlFile(file: FormData) {
        return this.post("/ImportXml", file)
    }

    exportXmlFile(languageId: string) {
        return this.get("/ExportXml", {
            params: {
                id: languageId
            }
        })
    }


}

export const languageServices = new LanguageService();